import { createElement } from 'react';
import {
    AUDIT_AVATAR_NAME,
    CURATIVE_AVATARS_NAMES,
    CURATIVE_FORM_ABRASION_WEAR_LAYER_NAME,
    CURATIVE_FORM_ANKLE_IMPACT_NAME,
    CURATIVE_FORM_CRACK_NAME,
    CURATIVE_FORM_FLATNESS_NAME,
    CURATIVE_FORM_OTHERS_NAME,
    CURATIVE_FORM_PAVING_IMPACT_NAME,
    CURATIVE_FORM_PIANAGE_NAME,
    CURATIVE_FORM_SPALLS_NAME, TREATMENT_AVATARS_NAMES,
    TREATMENT_FORM_CLASSIC_PROTECTIVE_LAYER_NAME,
    TREATMENT_FORM_COLORING_OF_PAVING_OUTSIDE_AGGREGATE_NAME,
    TREATMENT_FORM_COVERING_PAVING_MARKING_COLORING_NAME,
    TREATMENT_FORM_EXTERIOR_HARDENER_DESNSIFICATION_NAME,
    TREATMENT_FORM_HARDENER_INTERIOR_DENSIFICATION_WATER_REPELLENT_NAME,
    TREATMENT_FORM_HARDENER_INTERIOR_DESINFICATION_NAME,
    TREATMENT_FORM_HIGH_TRAFFIC_PROTECTION_LAYER_NAME,
    TREATMENT_FORM_SANDING_NAME,
    TREATMENT_FORM_STRIPPING_NAME,
    TREATMENT_FORM_SURFACE_CLEANING_NAME
} from '@/utils/CONST';
import AnkleImpactForm from '@/components/common/forms/curative/ankle-impact-form/ankle-impact-form';
import AbrasionWearLayerForm from '@/components/common/forms/curative/abrasion-wear-layer-form/abrasion-wear-layer-form';
import CrackForm from '@/components/common/forms/curative/crack-form/crack-form';
import FlatnessForm from '@/components/common/forms/curative/flatness-form/flatness-form';
import OthersForm from '@/components/common/forms/curative/others-form/others-form';
import PavingImpactForm from '@/components/common/forms/curative/paving-impact-form/paving-impact-form';
import PianageForm from '@/components/common/forms/curative/pianage-form/pianage-form';
import SurfaceCleaningForm from '@/components/common/forms/treatment/surface-cleaning-form/surface-cleaning-form';
import StrippingForm from '@/components/common/forms/treatment/stripping-form/stripping-form';
import SpallsForm from '@/components/common/forms/curative/spalls-form/spalls-form';
import SandingForm from '@/components/common/forms/treatment/sanding-form/sanding-form';
import HardenerInteriorDesinficationForm from '@/components/common/forms/treatment/hardener-interior-desinfication-form/hardener-interior-desinfication-form';
import HardenerExteriorDesinficationForm from '@/components/common/forms/treatment/hardener-exterior-desinfication-form/hardener-exterior-desinfication-form';
import HardenerInteriorDensificationWaterRepellentForm from '@/components/common/forms/treatment/hardener-interior-densification-water-repellent-form/hardener-interior-densification-water-repellent-form';
import ClassicProtectiveLayerForm from '@/components/common/forms/treatment/classic-protective-layer-form/classic-protective-layer-form';
import HighTrafficProtectionLayerForm from '@/components/common/forms/treatment/high-traffic-protection-layer-form/high-traffic-protection-layer-form';
import ColoringPavingMarkingColoringForm from '@/components/common/forms/treatment/coloring-paving-marking-coloring-form/coloring-paving-marking-coloring-form';
import ColoringOfPavingOutsideAggregateForm from '@/components/common/forms/treatment/coloring-of-paving-outside-aggregate-form/coloring-of-paving-outside-aggregate-form';
import AuditForm from '@/components/common/forms/audit-form/audit-form';

const formsResolverInscriptions: any = {
    [CURATIVE_AVATARS_NAMES[CURATIVE_FORM_ABRASION_WEAR_LAYER_NAME]]: AbrasionWearLayerForm,
    [CURATIVE_AVATARS_NAMES[CURATIVE_FORM_ANKLE_IMPACT_NAME]]: AnkleImpactForm,
    [CURATIVE_AVATARS_NAMES[CURATIVE_FORM_CRACK_NAME]]: CrackForm,
    [CURATIVE_AVATARS_NAMES[CURATIVE_FORM_FLATNESS_NAME]]: FlatnessForm,
    [CURATIVE_AVATARS_NAMES[CURATIVE_FORM_OTHERS_NAME]]: OthersForm,
    [CURATIVE_AVATARS_NAMES[CURATIVE_FORM_PAVING_IMPACT_NAME]]: PavingImpactForm,
    [CURATIVE_AVATARS_NAMES[CURATIVE_FORM_PIANAGE_NAME]]: PianageForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_SURFACE_CLEANING_NAME]]: SurfaceCleaningForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_STRIPPING_NAME]]: StrippingForm,
    [CURATIVE_AVATARS_NAMES[CURATIVE_FORM_SPALLS_NAME]]: SpallsForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_SANDING_NAME]]: SandingForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_HARDENER_INTERIOR_DESINFICATION_NAME]]: HardenerInteriorDesinficationForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_EXTERIOR_HARDENER_DESNSIFICATION_NAME]]: HardenerExteriorDesinficationForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_HARDENER_INTERIOR_DENSIFICATION_WATER_REPELLENT_NAME]]:
        HardenerInteriorDensificationWaterRepellentForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_CLASSIC_PROTECTIVE_LAYER_NAME]]: ClassicProtectiveLayerForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_HIGH_TRAFFIC_PROTECTION_LAYER_NAME]]: HighTrafficProtectionLayerForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_COVERING_PAVING_MARKING_COLORING_NAME]]: ColoringPavingMarkingColoringForm,
    [TREATMENT_AVATARS_NAMES[TREATMENT_FORM_COLORING_OF_PAVING_OUTSIDE_AGGREGATE_NAME]]:
        ColoringOfPavingOutsideAggregateForm,
    [AUDIT_AVATAR_NAME]:
    AuditForm,
};

interface Props {
    name: string;
    [key: string]: any;
}

const FormsResolver = ({ name, ...restProps }: Props) =>
    createElement(formsResolverInscriptions[name] ?? null, restProps);

export default FormsResolver;
